var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFondoIndicadores(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1871.43,
    height: 315,
    viewBox: "0 0 1871.43 315",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1857",
    "data-name": "Grupo 1857",
    transform: "translate(-705.7 -1137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6504",
    "data-name": "Trazado 6504",
    d: "M219.121,160.579l153,152.483,153-152.483L372.124,8.1Z",
    transform: "translate(920 1137)",
    fill: "rgba(255,255,255,0.15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6505",
    "data-name": "Trazado 6505",
    d: "M-84.755,185.9H29.333L.9,214.351-100.211,315H-214.3Z",
    transform: "translate(920 1137)",
    fill: "rgba(255,255,255,0.15)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6506",
    "data-name": "Trazado 6506",
    d: "M-214.3,0h114.089L.9,100.65,29.333,129.1H-84.755Z",
    transform: "translate(920 1137)",
    fill: "rgba(255,255,255,0.15)",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6507",
    "data-name": "Trazado 6507",
    d: "M37.474,185.9H151.563L281.107,315H167.018L66.026,214.351Z",
    transform: "translate(920 1137)",
    fill: "rgba(255,255,255,0.15)",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6508",
    "data-name": "Trazado 6508",
    d: "M167.018,0H281.107L151.563,129.1H37.474L66.026,100.65Z",
    transform: "translate(920 1137)",
    fill: "rgba(255,255,255,0.15)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6509",
    "data-name": "Trazado 6509",
    d: "M906.973,160.563,1059.98,313.046l153-152.483L1059.98,8.08Z",
    transform: "translate(920 1137)",
    fill: "rgba(255,255,255,0.15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6510",
    "data-name": "Trazado 6510",
    d: "M603.2,185.9H717.286l-28.433,28.455L587.742,315H473.654Z",
    transform: "translate(920 1137)",
    fill: "rgba(255,255,255,0.15)",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6511",
    "data-name": "Trazado 6511",
    d: "M473.654,0H587.742L688.853,100.649,717.286,129.1H603.2Z",
    transform: "translate(920 1137)",
    fill: "rgba(255,255,255,0.15)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6512",
    "data-name": "Trazado 6512",
    d: "M720,235.515l37.4,37.273L799.756,315H640.244L682.6,272.788Z",
    transform: "translate(920 1137)",
    fill: "rgba(255,255,255,0.15)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6513",
    "data-name": "Trazado 6513",
    d: "M720,79.485,682.6,42.212,640.244,0H799.756L757.282,42.212Z",
    transform: "translate(920 1137)",
    fill: "rgba(255,255,255,0.15)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6514",
    "data-name": "Trazado 6514",
    d: "M1403.94,235.515l37.52,37.273L1483.7,315H1324.3l42.36-42.212Z",
    transform: "translate(920 1137)",
    fill: "rgba(255,255,255,0.15)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6515",
    "data-name": "Trazado 6515",
    d: "M1403.94,79.485l-37.4-37.273L1324.3,0h159.4l-42.36,42.212Z",
    transform: "translate(920 1137)",
    fill: "rgba(255,255,255,0.15)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6516",
    "data-name": "Trazado 6516",
    d: "M32.047,235.515l37.4,37.273L111.685,315H-47.709l42.356-42.212Z",
    transform: "translate(920 1137)",
    fill: "rgba(255,255,255,0.15)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6517",
    "data-name": "Trazado 6517",
    d: "M32.047,79.485l-37.4-37.273L-47.709,0H111.685L69.329,42.212Z",
    transform: "translate(920 1137)",
    fill: "rgba(255,255,255,0.15)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6518",
    "data-name": "Trazado 6518",
    d: "M725.427,185.9H839.516L969.06,315H854.972L753.979,214.351Z",
    transform: "translate(920 1137)",
    fill: "rgba(255,255,255,0.15)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6519",
    "data-name": "Trazado 6519",
    d: "M854.971,0H969.06L839.516,129.1H725.427l28.552-28.455Z",
    transform: "translate(920 1137)",
    fill: "rgba(255,255,255,0.15)",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6520",
    "data-name": "Trazado 6520",
    d: "M1291.15,185.9h114.09l-28.43,28.454L1275.7,315H1161.61Z",
    transform: "translate(920 1137)",
    fill: "rgba(255,255,255,0.15)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6521",
    "data-name": "Trazado 6521",
    d: "M1161.61,0H1275.7l101.11,100.649,28.43,28.455H1291.15Z",
    transform: "translate(920 1137)",
    fill: "rgba(255,255,255,0.15)",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6522",
    "data-name": "Trazado 6522",
    d: "M1413.5,185.9h114.09L1657.13,315H1543.04L1442.05,214.35Z",
    transform: "translate(920 1137)",
    fill: "rgba(255,255,255,0.15)",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6523",
    "data-name": "Trazado 6523",
    d: "M1543.04,0h114.09L1527.59,129.1H1413.5l28.55-28.455Z",
    transform: "translate(920 1137)",
    fill: "rgba(255,255,255,0.15)",
    opacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFondoIndicadores);
export default __webpack_public_path__ + "static/media/fondo_indicadores.faae61a6cf3009bef5abcdcffdb40e59.svg";
export { ForwardRef as ReactComponent };